 // Bildpuffar
const puffLists = document.querySelectorAll('.puffar ul');

// foeach bildpuff section cont the number of puffar
puffLists.forEach(list => {

    list.classList.add('col-' + list.childElementCount);

});